import { useDispatch } from 'react-redux';
import { Col, Alert, Spinner, Row, Card, CardHeader, CardBody, } from 'reactstrap';
import { useNavigate } from 'react-router-dom';
import { createSelector } from 'reselect';
import React, { useEffect, useMemo, useState } from 'react';
import { useSelector } from 'react-redux';
import { getCostCenterList, getCostCenterQuery } from '../../../slices/thunks';
import { Link } from 'react-router-dom';
import AddEditCostCenterModal from './Add_Edit/AddEditCostCenterModal';
import DeleteCostCenterModal from './Delete/DeleteCostCenter';
import { ODataGrid } from '../../../Components/OElements/ODataGrid';
import ImportCostCenterModal from './Add_Edit/ImportCostCenter';

const CostCenterList = () => {
	const dispatch = useDispatch();
	const history = useNavigate();

	const selectorCostCenter = createSelector(
		state => state.CostCenter,
		cost_center => ({
			costCenterList: cost_center.costCenterList,
			isLoadingList: cost_center.isLoadingList,
			isCostCenterSuccess: cost_center.isCostCenterSuccess,
			error: cost_center.error,
			isAdding: cost_center.isAdding,
			isAdded: cost_center.isAdded,
			isAddError: cost_center.isAddError,
			isUpdating: cost_center.isUpdating,
			isUpdated: cost_center.isUpdated,
			isUpdateError: cost_center.isUpdateError,
			isDeleting: cost_center.isDeleting,
			isDeleted: cost_center.isDeleted,
			isDeleteError: cost_center.isDeleteError,
		})
	);

	// const selectRolesList = createSelector(
	// 	state => state.Roles.roleListSelect,
	// 	roleListSelect => roleListSelect
	// );

	// const roleListSelect = useSelector(selectRolesList);

	const { costCenterList, isLoadingList } = useSelector(selectorCostCenter);

	useEffect(() => {
		dispatch(getCostCenterQuery());
	}, []);

	const [dataCostCenter, setDataCostCenter] = useState({});
	const [isEdit, setIsEdit] = useState(false);

	// Delete CostCenter
	const [modalImport, setModalImport] = useState(false);
	const [modal, setModal] = useState(false);
	const [modalDelete, setModalDelete] = useState(false);
	//Tab
	const [activeTab, setActiveTab] = useState('1');
	const toggleTab = tab => {
		if (activeTab !== tab) {
			setActiveTab(tab);
		}
	};

	function handleToggleModal() {
		setModal(!modal);
		toggleTab('1');
		// validation.resetForm();
	}

	function handleToggleModalDelete() {
		setModalDelete(!modalDelete);
	}

	// Delete Data
	const handleClickDelete = cost_center => {
		setDataCostCenter(cost_center);
		setModalDelete(true);
	};

	// Update Data
	const handleClickEdit = cost_center => {
		setDataCostCenter(cost_center);
		handleToggleModal();
	};

	function handleToggleModalImport() {
		setModalImport(!modalImport);
	}

	const columns = useMemo(
		() => [
			{
				header: 'Acciones', enableSorting: false, enableColumnFilter: false, enableGlobalFilter: false, enableColumnActions: false,
				accessorKey: 'cost_center',
				columnDefType: 'display',
				size: 'auto',
				Cell: cellProps => {
					return (
						<React.Fragment>
							<div className='d-flex'>
								<div className='flex-shrink-0'>
									<ul className='list-inline mb-0'>
										<li className='list-inline-item'>
											<Link
												to='#'
												onClick={() => {
													const cost_centerData =
														cellProps.row.original;
													setIsEdit(true);
													handleClickEdit(cost_centerData);
												}}
											>
												<i className='ri-pencil-fill align-bottom me-2 text-muted'></i>
											</Link>
										</li>
										<li className='list-inline-item'>
											<Link
												to='#'
												className='remove-item-btn'
												onClick={() => {
													const cost_centerData =
														cellProps.row.original;
													handleClickDelete(cost_centerData);
												}}
											>
												<i className='ri-delete-bin-line align-bottom me-2 text-muted'></i>
											</Link>
										</li>
									</ul>
								</div>
							</div>
						</React.Fragment>
					);
				},
			}, 
			{
				header: 'Nombre Centro de Costo',
				accessorKey: 'name',
				dataType: 'multi-select',
				size: 'auto',
			},
			{
				header: 'Código',
				accessorKey: 'code',
				size: 'auto',
			},
			{
				header: 'Empresa',
				accessorKey: 'company.name',
				dataType: 'multi-select',
				size: 'auto',
			}
		],
		[handleClickEdit]
	);

	return (
		<React.Fragment>
			<Row>
				<Col lg={12}>
					<Card>
						{/* <CardHeader className='border-0 pb-0'>
							<div className='d-flex align-items-end justify-content-end'>
								<div className='flex-shrink-0'>
									<div className='d-flex flex-wrap gap-2'>
										<button
											className='btn btn-label btn-primary'
											onClick={() => {
												handleToggleModalImport();
											}}
										>
											<i className='icon-download label-icon'></i>{' '}
											Importar Centros de Costo
										</button>
										<button
											className='btn btn-label btn-primary'
											onClick={() => {
												setIsEdit(false);
												setDataCostCenter({});
												handleToggleModal();
											}}
										>
											<i className={`${Icons.plus} label-icon`}></i>{' '}
											Crear Centro de Costo
										</button>
									</div>
								</div>
							</div>
						</CardHeader> */}
						<CardBody>
							<ODataGrid
								columns={columns}
								getDataFunc={getCostCenterQuery}
								nameFile={'centro_de_costo'}
								queryPopulate={[
									'company'
								]}
								remoteOperations={{
									pagination: true,
									sorting: true,
									filtering: true,
								}}
								defaultPageSize={20}
								customToolbarActions={[
									{
										label: 'Importar',
										icon: 'icon-download',
										className: 'gap-1',
										onClick: () => {handleToggleModalImport();},
										title: 'Importar Centros de Costo',
									},
									{
										label: 'Crear',
										icon: Icons.plus,
										onClick: () => {
											setIsEdit(false);
											setDataCostCenter({});
											handleToggleModal();
										},
										title: 'Crear Centro de Costo',
									}
								]}
							/>
						</CardBody>
					</Card>
				</Col>
			</Row>

			<ImportCostCenterModal
				isEdit={isEdit}
				isOpen={modalImport}
				handleToggleModalImport={handleToggleModalImport}
				activeTab={activeTab}
				toggleTab={toggleTab}
			/>

			<AddEditCostCenterModal
				dataCostCenter={dataCostCenter}
				isEdit={isEdit}
				isOpen={modal}
				handleToggleModal={handleToggleModal}
				activeTab={activeTab}
				toggleTab={toggleTab}
			/>
			<DeleteCostCenterModal
				dataCostCenter={dataCostCenter}
				isOpen={modalDelete}
				handlerToggleModal={handleToggleModalDelete}
			/>
		</React.Fragment>
	);
};

export default CostCenterList;
